import React from "react";
import { TextField } from "@mui/material";
import { styled } from "@mui/system";
 
const StyledTextField = styled(TextField)({
  width: "100%",
  marginBottom: "10px",

  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#f9fafb",
    transition: "all 0.2s ease",

    "& fieldset": {
      borderColor: "#d1d5db",
    },

    "&:hover fieldset": {
      borderColor: "#6366f1",
    },

    "&.Mui-focused fieldset": {
      borderColor: "#4f46e5",
      borderWidth: "2px",
    },
  },

  "& .MuiOutlinedInput-input": {
    // padding: "12px 14px",
    fontSize: "14px",
  },

  "& .MuiInputLabel-root": {
    fontSize: "14px",
  },

  "& .MuiInputLabel-root.Mui-focused": {
    color: "#4f46e5",
  },
});
 
const Textfield = (props) => {
  const {
    id,
    name,
    label,
    type,
    variant,
    value,
    handleOnChange: onChange,
    onBlur,
    error,
    helperText,
    disabled,
  } = props;
  const fieldProps = {
    id,
    name,
    label,
    type,
    variant,
    value,
    onChange,
    error,
    helperText,
    onBlur,
    disabled,
  };
  return <StyledTextField {...fieldProps} />;
};
 
export default Textfield;